const STATUSCODE = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNPROCESSABLE: 422,
  SERVER_ERROR: 500,
  MAXIMUM_DATA: 413,
};
export default STATUSCODE;
